import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useAuth } from './AuthContext';
import './ProductAdminPanel.css';

const API = 'https://metallpererabotka.ru/api';

const ProductAdminPanel = () => {
  const { user } = useAuth();

  const [products, setProducts] = useState([]);
  const [editingProductId, setEditingProductId] = useState(null);
  const [editFormData, setEditFormData] = useState({});
  const [formData, setFormData] = useState({
    name: '',
    description: '',
    price: '',
    stock: '',
    link_ozon: '',
    link_wb: '',
    link_yandex: '',
  });

  useEffect(() => { if (user?.is_staff) fetchProducts(); }, [user]);

  const fetchProducts = async () => {
    try {
      const res = await axios.get(`${API}/admin/products/`, { withCredentials: true });
      setProducts(res.data);
    } catch (err) {
      console.error('Ошибка загрузки товаров:', err);
    }
  };

  // -------------------- Добавление товара (как было) --------------------
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };


  const handleAddProduct = async (e) => {
    e.preventDefault();
    const data = new FormData();
    Object.entries(formData).forEach(([k, v]) => {
      if (v !== '' && v !== null && v !== undefined) data.append(k, v);
    });

    try {
      await axios.post(`${API}/admin/products/`, data, {
        headers: { 'Content-Type': 'multipart/form-data' },
        withCredentials: true,
      });
      setFormData({
        name: '', description: '', price: '', stock: '',
        link_ozon: '', link_wb: '', link_yandex: '',
      });
      fetchProducts();
    } catch (err) {
      console.error('Ошибка добавления товара:', err.response?.data || err.message);
    }
  };

  const handleDeleteProduct = async (id) => {
    try {
      await axios.delete(`${API}/admin/products/${id}/`, { withCredentials: true });
      fetchProducts();
    } catch (err) {
      console.error('Ошибка удаления товара:', err);
    }
  };

  // -------------------- Редактирование товара (как было) --------------------
  const startEdit = (product) => {
    setEditingProductId(product.id);
    setEditFormData({ ...product }); // product уже содержит images[]
  };

  const cancelEdit = () => {
    setEditingProductId(null);
    setEditFormData({});
  };

  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditFormData((prev) => ({ ...prev, [name]: value }));
  };

  const saveEdit = async () => {
    try {
      const data = new FormData();
      Object.entries(editFormData).forEach(([key, value]) => {
        if (value !== '' && value !== null && value !== undefined) {
          data.append(key, value);
        }
      });
      await axios.patch(`${API}/admin/products/${editingProductId}/`, data, {
        headers: { 'Content-Type': 'multipart/form-data' },
        withCredentials: true,
      });
      setEditingProductId(null);
      setEditFormData({});
      fetchProducts();
    } catch (err) {
      console.error('Ошибка при сохранении редактирования:', err.response?.data || err.message);
    }
  };


  // -------------------- ГАЛЕРЕЯ: загрузка/удаление/основное/порядок --------------------
  const uploadImages = async (productId, files, { is_primary = false, alt = '' } = {}) => {
    if (!files?.length) return;
    const data = new FormData();
    [...files].forEach((f) => data.append('images', f)); // поле images[]
    if (alt) data.append('alt', alt);
    if (is_primary) data.append('is_primary', 'true');

    try {
      await axios.post(`${API}/admin/products/${productId}/images/`, data, {
        headers: { 'Content-Type': 'multipart/form-data' },
        withCredentials: true,
      });
      fetchProducts();
    } catch (err) {
      console.error('Ошибка загрузки изображений:', err.response?.data || err.message);
    }
  };

  const deleteImage = async (productId, imgId) => {
    try {
      await axios.delete(`${API}/admin/products/${productId}/images/${imgId}/`, {
        withCredentials: true,
      });
      fetchProducts();
    } catch (err) {
      console.error('Ошибка удаления изображения:', err.response?.data || err.message);
    }
  };

  const setPrimary = async (productId, imgId) => {
    try {
      await axios.patch(`${API}/admin/products/${productId}/images/${imgId}/set-primary/`, {}, {
        withCredentials: true,
      });
      fetchProducts();
    } catch (err) {
      console.error('Ошибка назначения основного изображения:', err.response?.data || err.message);
    }
  };

const reorderImages = async (productId, items /* [{id, position}] */) => {
  try {
    await axios.post(
      `${API}/admin/products/${productId}/images/reorder/`,
      items, // массив [{id, position}]
      {
        withCredentials: true,
        headers: { 'Content-Type': 'application/json' },
      }
    );
    fetchProducts();
  } catch (err) {
    console.error('Ошибка переупорядочивания:', err.response?.data || err.message);
  }
};


  if (!user?.is_staff) return <p>У вас нет доступа к админ-панели.</p>;

  return (
    <div className="product-admin-panel">
      <h2>Панель управления товарами</h2>

      {/* -------------------- ФОРМА ДОБАВЛЕНИЯ -------------------- */}
     <form onSubmit={handleAddProduct} className="add-form">
      <input name="name" placeholder="Название" value={formData.name} onChange={handleInputChange} required />
      <input name="price" type="number" placeholder="Цена" value={formData.price} onChange={handleInputChange} required />
      <input name="stock" type="number" placeholder="Остаток" value={formData.stock} onChange={handleInputChange} required />
      <textarea name="description" placeholder="Описание" value={formData.description} onChange={handleInputChange} />

      <input name="link_ozon" placeholder="Ссылка на Ozon" value={formData.link_ozon} onChange={handleInputChange} />
      <input name="link_wb" placeholder="Ссылка на Wildberries" value={formData.link_wb} onChange={handleInputChange} />
      <input name="link_yandex" placeholder="Ссылка на Яндекс Маркет" value={formData.link_yandex} onChange={handleInputChange} />

      <button type="submit">Добавить товар</button>
    </form>


      {/* -------------------- СПИСОК ТОВАРОВ -------------------- */}
      <div className="product-list">
        {products.map((p) => {
          const cover = p.cover_image_url || p.image || '';
          const images = p.images || [];

          return (
            <div key={p.id} className="product-card">
              {editingProductId === p.id ? (
                <>
                  <input name="name" value={editFormData.name || ''} onChange={handleEditChange} />
                  <input name="price" type="number" value={editFormData.price || ''} onChange={handleEditChange} />
                  <input name="stock" type="number" value={editFormData.stock || ''} onChange={handleEditChange} />
                  <textarea name="description" value={editFormData.description || ''} onChange={handleEditChange} />

                  <input name="link_ozon" placeholder="Ссылка на Ozon" value={editFormData.link_ozon || ''} onChange={handleEditChange} />
                  <input name="link_wb" placeholder="Ссылка на Wildberries" value={editFormData.link_wb || ''} onChange={handleEditChange} />
                  <input name="link_yandex" placeholder="Ссылка на Яндекс Маркет" value={editFormData.link_yandex || ''} onChange={handleEditChange} />

                  <button onClick={saveEdit}>Сохранить</button>
                  <button onClick={cancelEdit}>Отмена</button>
                </>
              ) : (
                <>
                  <h3>{p.name}</h3>
                  <div className="cover-line">
                    {cover ? <img src={cover} alt={p.name} /> : <div className="no-cover">Нет обложки</div>}
                  </div>
                  <div className="meta">
                    <div>Цена: {p.price} ₽</div>
                    <div>Остаток: {p.stock}</div>
                  </div>

                  <button onClick={() => startEdit(p)}>Редактировать</button>
                  <button onClick={() => handleDeleteProduct(p.id)}>Удалить товар</button>
                </>
              )}

              {/* -------------------- ГАЛЕРЕЯ ТОВАРА -------------------- */}
              <div className="gallery">
                <div className="gallery-head">
                  <label className="file-button">
                    Загрузить карточки товара...
                    <input
                      type="file"
                      accept="image/*"
                      multiple
                      style={{ display: 'none' }}
                      onChange={(e) => {
                        const files = e.target.files;
                        if (files?.length) uploadImages(p.id, files);
                        e.target.value = null;
                      }}
                    />
                  </label>
                </div>

                {images.length === 0 ? (
                  <div className="muted">Фотографий пока нет</div>
                ) : (
                  <div className="thumbs-grid">
                    {images.map((im) => (
                      <div className="thumb" key={im.id}>
                        <img src={im.url} alt={im.alt || ''} />
                        <div className="thumb-actions">
                          {!im.is_primary ? (
                            <button onClick={() => setPrimary(p.id, im.id)}>Сделать основной</button>
                          ) : (
                            <span className="primary-badge">Основное фото</span>
                          )}
                          <button className="danger" onClick={() => deleteImage(p.id, im.id)}>Удалить</button>
                        </div>
                      </div>
                    ))}
                  </div>
                )}

                {/* Пример простой расстановки позиций: первая колонка — position по индексу */}
                {images.length > 1 && (
                  <button
                    className="outline"
                    onClick={() =>
                      reorderImages(
                        p.id,
                        p.images.map((im, idx) => ({ id: im.id, position: idx }))
                      )
                    }
                  >
                    Сохранить
                  </button>

                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ProductAdminPanel;
